import React from 'react';
// import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from "react-router-dom";
// import reportWebVitals from './reportWebVitals';
import {configureStore} from "./store/store";
import App from './App';
import i18n from './configs/i18n';
import { createRoot } from 'react-dom/client';

// ReactDOM.render(
  // <I18nextProvider i18n={i18n}>
  //   <Provider store={configureStore({})}>
  //     <React.Fragment>
  //       <BrowserRouter>
  //         <App />
  //       </BrowserRouter>
  //     </React.Fragment>
  //   </Provider>
  // </I18nextProvider>,
//   document.getElementById('root')
// );
// reportWebVitals();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={configureStore({})}>
      <React.Fragment>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Fragment>
    </Provider>
  </I18nextProvider>
);
// reportWebVitals();